import styles from './ActionTab.module.scss'
import { useAppSelector } from '../../../hooks/useAppSelector'
import React, { memo } from 'react'
import { toSentenceCase } from '../../../utils/toSentenceCase'
import { selectOneCustomAction } from '../../../store/selectors/actionsSelectors/actionsSelectors'

interface ActionTabProps {
    guid: string
    actionName: string
    activeActionName: string
    onActionTabClick: (actionName: string) => void
}

export const ActionTab = memo(function ActionTab(props: ActionTabProps) {
    const { guid, actionName, activeActionName, onActionTabClick } = props

    const currentAction = useAppSelector(selectOneCustomAction(guid, actionName))
    const actionNameBeautified = toSentenceCase(actionName)
    const isActive = activeActionName === actionName
    const handleActionClick = () => onActionTabClick(actionName)

    return (
        <div
            className={`${styles.actionTab} ${isActive && styles.active}`}
            onClick={handleActionClick}
        >
            <strong>{actionNameBeautified}</strong>
            {!!currentAction.description && (
                <p className={styles.description}>
                    {currentAction.description}
                </p>
            )}
        </div>
    )
})
